import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { EyeIcon } from "../../../../styles/img/svg/EyeIcon";

export const UiInput = (props) => {
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    };
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    return (
        <>
            <div className="sb-input-wrapper">
                <Form.Group controlId={props.id}>
                    {props.label && <Form.Label>{props.label}</Form.Label>}

                    {props.inputhideicon ? (
                        <Form.Control
                            type={passwordType}
                            name="password"
                            placeholder={props.placeholder}
                        />
                    ) : (
                        <Form.Control
                            type={props.type}
                            placeholder={props.placeholder}
                            // value={props.value}
                            onChange={(e) => {}}
                        />
                    )}

                    {!props.error && (
                        <>
                            {props.inputhideicon && (
                                <div
                                    onClick={togglePassword}
                                    className={
                                        passwordType === "password"
                                            ? ""
                                            : "sb-input-wrapper__sb-view"
                                    }
                                >
                                    <EyeIcon />
                                </div>
                            )}
                        </>
                    )}
                </Form.Group>
            </div>
        </>
    );
};

export const UiInputLink = (props) => {
    return (
        <>
            <div className="sb-input-link">
                <Link to={props.link}>{props.text}</Link>
            </div>
        </>
    );
};

export const UiCheckboxInput = (props) => {
    return (
        <>
            <div className="sb-radio-input-wrapper">
                <div key={props.type} className="sb-radio-input-wrapper__flex">
                    <Form.Check
                        type={props.type}
                        name={props.name}
                        id={props.id}
                        checked={props.checked}
                        label={props.label}
                        onChange={props.onChange}
                    />

                    {props.link && (
                        <>
                            <label
                                htmlFor={props.for}
                                className="sb-radio-input-wrapper__flex__label"
                            >
                                {props.linkLabel}
                            </label>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
export const UiCheckbox = (props) => {
    return (
        <>
            <div className="sb-radio-input-wrapper">
                <div key={props.type} className="sb-radio-input-wrapper__flex">
                    <Form.Check
                        type={props.type}
                        name={props.name}
                        id={props.id}
                        label={props.label}
                        onClick={props.onClick}
                        value={props.checked}
                    />

                    {props.linkLabel && (
                        <>
                            <label
                                htmlFor={props.for}
                                className="sb-radio-input-wrapper__flex__label"
                            >
                                {props.linkLabel}
                            </label>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export const UiInputOtp = (props) => {
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    };
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    return (
        <>
            <div className="sb-input-wrapper">
                <Form.Group controlId="formPlaintextEmail">
                    <Form.Label>{props.label}</Form.Label>

                    <Form.Control
                        type={props.type}
                        placeholder={props.placeholder}
                        className={
                            props.size ? "sb-input-size-" + props.size : ""
                        }
                    />
                </Form.Group>
            </div>
        </>
    );
};
